import type { FeatureToggles } from '~/lib/ContentfulGraphqlService/validation/featureTogglesSchema';

export default function useModernCheckout(): boolean {
  const { $locale, $globalPageSettings } = useNuxtApp();

  const featureToggles = $globalPageSettings.value?.featureToggles ?? {};
  const feature = `usewebappCheckout_${convertContentfulToWebappLocaleCode(
    $locale.value
  )}`;

  return (
    feature in featureToggles &&
    (featureToggles[
      feature as Exclude<keyof FeatureToggles, 'useContentPageCache'>
    ] === true ||
      featureToggles[
        feature as Exclude<keyof FeatureToggles, 'useContentPageCache'>
      ] === 1)
  );
}
